import { render } from "./TalkBlockComponent.vue?vue&type=template&id=72094791&scoped=true"
import script from "./TalkBlockComponent.vue?vue&type=script&lang=js"
export * from "./TalkBlockComponent.vue?vue&type=script&lang=js"

import "./TalkBlockComponent.vue?vue&type=style&index=0&id=72094791&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72094791"

export default script